export const calculateLumpSumDiscountPerItem = ({ row, lumpSumDiscountAmount = 0, quotationTotalPrice = 0 }) => {
  const quantity = Number(row?.quantity ?? 0)
  const unitRate = Number(row?.unitRate ?? 0)
  const discount = Number(row?.discount ?? 0)

  const grossAmountPerUnit = unitRate * (1 - discount / 100)

  if (!lumpSumDiscountAmount || !quotationTotalPrice || !quantity) {
    return 0
  }

  const rowAmount = quantity * grossAmountPerUnit
  return ((rowAmount / quotationTotalPrice) * lumpSumDiscountAmount) / quantity
}

export const calculateRequestedCost = ({ row, lumpSumDiscountAmount = 0, quotationTotalPrice = 0 }) => {
  const newRequestedQuantity = Number(row?.newRequestedQuantity ?? 0)
  const unitRate = Number(row?.unitRate ?? 0)
  const discount = Number(row?.discount ?? 0)
  const quantity = Number(row?.quantity ?? 0)

  const grossAmountPerUnit = unitRate * (1 - discount / 100)
  const baseCost = newRequestedQuantity * grossAmountPerUnit

  if (!lumpSumDiscountAmount || !quotationTotalPrice || !quantity) {
    return baseCost
  }

  const lumpSumDiscountPerItem = calculateLumpSumDiscountPerItem({
    row,
    lumpSumDiscountAmount,
    quotationTotalPrice,
  })

  return newRequestedQuantity * (grossAmountPerUnit - lumpSumDiscountPerItem)
}
